import { PropertyAttribute } from "@eemo/api-client";

export class PropertyAttributeHelper {

  static FLOOR = 'FLOOR_NB';
  static NUM = 'REF_FLAT';

  static getFloor(propAttrs: PropertyAttribute[]): string | null {
    return propAttrs.find(p => p.code === PropertyAttributeHelper.FLOOR)?.value || null;
  }

  static getNum(propAttrs: PropertyAttribute[]): string | null {
    return propAttrs.find(p => p.code === PropertyAttributeHelper.NUM)?.value || null;
  }
}
